const countryTranslations = {
    en: {
        AF:"Afghanistan",
        AX:"Åland Islands",
        AL:"Albania",
        DZ:"Algeria",
        AS:"American Samoa",
        AD:"Andorra",
        AO:"Angola",
        AI:"Anguilla",
        AQ:"Antarctica",
        AG:"Antigua and Barbuda",
        AR:"Argentina",
        AM:"Armenia",
        AW:"Aruba",
        AU:"Australia",
        AT:"Austria",
        AZ:"Azerbaijan",
        BS:"Bahamas",
        BH:"Bahrain",
        BD:"Bangladesh",
        BB:"Barbados",
        BY:"Belarus",
        BE:"Belgium",
        BZ:"Belize",
        BJ:"Benin",
        BM:"Bermuda",
        BT:"Bhutan",
        BO:"Bolivia",
        BA:"Bosnia and Herzegovina",
        BW:"Botswana",
        BV:"Bouvet Island",
        BR:"Brazil",
        IO:"British Indian Ocean Territory",
        VG:"British Virgin Islands",
        BN:"Brunei",
        BG:"Bulgaria",
        BF:"Burkina Faso",
        BI:"Burundi",
        KH:"Cambodia",
        CM:"Cameroon",
        CA:"Canada",
        CV:"Cape Verde",
        BQ:"Caribbean Netherlands",
        KY:"Cayman Islands",
        CF:"Central African Republic",
        TD:"Chad",
        CL:"Chile",
        CN:"China",
        CX:"Christmas Island",
        CC:"Cocos Islands",
        CO:"Colombia",
        KM:"Comoros",
        CG:"Republic of the Congo",
        CD:"Democratic Republic of the Congo",
        CK:"Cook Islands",
        CR:"Costa Rica",
        CI:"Côte d’Ivoire",
        HR:"Croatia",
        CU:"Cuba",
        CW:"Curaçao",
        CY:"Cyprus",
        CZ:"Czechia",
        DK:"Denmark",
        DJ:"Djibouti",
        DM:"Dominica",
        DO:"Dominican Republic",
        EC:"Ecuador",
        EG:"Egypt",
        SV:"El Salvador",
        GQ:"Equatorial Guinea",
        ER:"Eritrea",
        EE:"Estonia",
        SZ:"Eswatini",
        ET:"Ethiopia",
        FK:"Falkland Islands",
        FO:"Faroe Islands",
        FJ:"Fiji",
        FI:"Finland",
        FR:"France",
        GF:"French Guiana",
        PF:"French Polynesia",
        TF:"French Southern Territories",
        GA:"Gabon",
        GM:"Gambia",
        GE:"Georgia",
        DE:"Germany",
        GH:"Ghana",
        GI:"Gibraltar",
        GR:"Greece",
        GL:"Greenland",
        GD:"Grenada",
        GP:"Guadeloupe",
        GU:"Guam",
        GT:"Guatemala",
        GG:"Guernsey",
        GN:"Guinea",
        GW:"Guinea-Bissau",
        GY:"Guyana",
        HT:"Haiti",
        HM:"Heard and McDonald Islands",
        HN:"Honduras",
        HK:"Hong Kong",
        HU:"Hungary",
        IS:"Iceland",
        IN:"India",
        ID:"Indonesia",
        IR:"Iran",
        IQ:"Iraq",
        IE:"Ireland",
        IM:"Isle of Man",
        IL:"Israel",
        IT:"Italy",
        JM:"Jamaica",
        JP:"Japan",
        JE:"Jersey",
        JO:"Jordan",
        KZ:"Kazakhstan",
        KE:"Kenya",
        KI:"Kiribati",
        XK:"Kosovo",
        KW:"Kuwait",
        KG:"Kyrgyzstan",
        LA:"Laos",
        LV:"Latvia",
        LB:"Lebanon",
        LS:"Lesotho",
        LR:"Liberia",
        LY:"Libya",
        LI:"Liechtenstein",
        LT:"Lithuania",
        LU:"Luxembourg",
        MO:"Macau",
        MG:"Madagascar",
        MW:"Malawi",
        MY:"Malaysia",
        MV:"Maldives",
        ML:"Mali",
        MT:"Malta",
        MH:"Marshall Islands",
        MQ:"Martinique",
        MR:"Mauritania",
        MU:"Mauritius",
        YT:"Mayotte",
        MX:"Mexico",
        FM:"Micronesia",
        MD:"Moldova",
        MC:"Monaco",
        MN:"Mongolia",
        ME:"Montenegro",
        MS:"Montserrat",
        MA:"Morocco",
        MZ:"Mozambique",
        MM:"Myanmar",
        NA:"Namibia",
        NR:"Nauru",
        NP:"Nepal",
        NL:"Netherlands",
        NC:"New Caledonia",
        NZ:"New Zealand",
        NI:"Nicaragua",
        NE:"Niger",
        NG:"Nigeria",
        NU:"Niue",
        NF:"Norfolk Island",
        KP:"North Korea",
        MK:"North Macedonia",
        MP:"Northern Mariana Islands",
        NO:"Norway",
        OM:"Oman",
        PK:"Pakistan",
        PW:"Palau",
        PS:"Palestine",
        PA:"Panama",
        PG:"Papua New Guinea",
        PY:"Paraguay",
        PE:"Peru",
        PH:"Philippines",
        PN:"Pitcairn Islands",
        PL:"Poland",
        PT:"Portugal",
        PR:"Puerto Rico",
        QA:"Qatar",
        RE:"Réunion",
        RO:"Romania",
        RU:"Russia",
        RW:"Rwanda",
        WS:"Samoa",
        SM:"San Marino",
        ST:"São Tomé and Príncipe",
        SA:"Saudi Arabia",
        SN:"Senegal",
        RS:"Serbia",
        SC:"Seychelles",
        SL:"Sierra Leone",
        SG:"Singapore",
        SX:"Sint Maarten",
        SK:"Slovakia",
        SI:"Slovenia",
        SB:"Solomon Islands",
        SO:"Somalia",
        ZA:"South Africa",
        GS:"South Georgia and South Sandwich Islands",
        KR:"South Korea",
        SS:"South Sudan",
        ES:"Spain",
        LK:"Sri Lanka",
        BL:"Saint Barthélemy",
        SH:"Saint Helena",
        KN:"Saint Kitts and Nevis",
        LC:"Saint Lucia",
        MF:"Saint Martin",
        PM:"Saint Pierre and Miquelon",
        VC:"Saint Vincent and the Grenadines",
        SD:"Sudan",
        SR:"Suriname",
        SJ:"Svalbard and Jan Mayen",
        SE:"Sweden",
        CH:"Switzerland",
        SY:"Syria",
        TW:"Taiwan",
        TJ:"Tajikistan",
        TZ:"Tanzania",
        TH:"Thailand",
        TL:"Timor-Leste",
        TG:"Togo",
        TK:"Tokelau",
        TO:"Tonga",
        TT:"Trinidad and Tobago",
        TN:"Tunisia",
        TR:"Turkey",
        TM:"Turkmenistan",
        TC:"Turks and Caicos Islands",
        TV:"Tuvalu",
        UM:"U.S. Outlying Islands",
        VI:"U.S. Virgin Islands",
        UG:"Uganda",
        UA:"Ukraine",
        AE:"United Arab Emirates",
        GB:"United Kingdom",
        US:"United States",
        UY:"Uruguay",
        UZ:"Uzbekistan",
        VU:"Vanuatu",
        VA:"Vatican City",
        VE:"Venezuela",
        VN:"Vietnam",
        WF:"Wallis and Futuna",
        EH:"Western Sahara",
        YE:"Yemen",
        ZM:"Zambia",
        ZW:"Zimbabwe"
    },
    pt: {
        AF:"Afeganistão",
        AX:"Ilhas Åland",
        AL:"Albânia",
        DZ:"Argélia",
        AS:"Samoa Americana",
        AD:"Andorra",
        AO:"Angola",
        AI:"Anguilla",
        AQ:"Antártica",
        AG:"Antigua e Barbuda",
        AR:"Argentina",
        AM:"Arménia",
        AW:"Aruba",
        AU:"Austrália",
        AT:"Austria",
        AZ:"Azerbaijão",
        BS:"Bahamas",
        BH:"Bahrain",
        BD:"Bangladesh",
        BB:"Barbados",
        BY:"Bielorússia",
        BE:"Bélgica",
        BZ:"Belize",
        BJ:"Benin",
        BM:"Bermuda",
        BT:"Butão",
        BO:"Bolívia",
        BA:"Bósnia e Herzegovina",
        BW:"Botswana",
        BV:"Ilha Bouvet",
        BR:"Brasil",
        IO:"Território Britânico do Oceano Índico",
        VG:"Ilhas Virgens Britânicas",
        BN:"Brunei",
        BG:"Bulgária",
        BF:"Burkina Faso",
        BI:"Burundi",
        KH:"Camboja",
        CM:"Camarões",
        CA:"Canadá",
        CV:"Cabo Verde",
        BQ:"Países Baixos Caribenhos",
        KY:"Ilhas Cayman",
        CF:"República Centro-Africana",
        TD:"Chade",
        CL:"Chile",
        CN:"China",
        CX:"Ilha Christmas",
        CC:"Ilhas Cocos",
        CO:"Colômbia",
        KM:"Comoros",
        CG:"República do Congo",
        CD:"Republica Democrática do Congo",
        CK:"Ilhas Cook",
        CR:"Costa Rica",
        CI:"Costa do Marfim",
        HR:"Croácia",
        CU:"Cuba",
        CW:"Curaçau",
        CY:"Chipre",
        CZ:"Chéquia",
        DK:"Dinamarca",
        DJ:"Djibouti",
        DM:"Dominica",
        DO:"República Dominicana",
        EC:"Ecuador",
        EG:"Egito",
        SV:"El Salvador",
        GQ:"Guiné Equatorial",
        ER:"Eritreia",
        EE:"Estónia",
        SZ:"Eswatini",
        ET:"Etiópia",
        FK:"Ilhas Malvinas",
        FO:"Ilhas Féroe",
        FJ:"Fiji",
        FI:"Finlândia",
        FR:"França",
        GF:"Guiana Francesa",
        PF:"Polinésia Francesa",
        TF:"Terras Austrais e Antárticas Francesas",
        GA:"Gabão",
        GM:"Gâmbia",
        GE:"Geórgia",
        DE:"Alemanha",
        GH:"Gana",
        GI:"Gibraltar",
        GR:"Grécia",
        GL:"Gronelândia",
        GD:"Granada",
        GP:"Guadalupe",
        GU:"Guam",
        GT:"Guatemala",
        GG:"Guernsey",
        GN:"Guiné",
        GW:"Guiné-Bissau",
        GY:"Guiana",
        HT:"Haiti",
        HM:"Ilha Heard e Ilhas McDonald",
        HN:"Honduras",
        HK:"Hong Kong",
        HU:"Hungria",
        IS:"Islândia",
        IN:"Índia",
        ID:"Indonésia",
        IR:"Irão",
        IQ:"Iraque",
        IE:"Irlanda",
        IM:"Ilha de Man",
        IL:"Israel",
        IT:"Itália",
        JM:"Jamaica",
        JP:"Japão",
        JE:"Jersey",
        JO:"Jordânia",
        KZ:"Cazaquistão",
        KE:"Quénia",
        KI:"Quiribáti",
        XK:"Kosovo",
        KW:"Kuwait",
        KG:"Quirguistão",
        LA:"Laos",
        LV:"Letónia",
        LB:"Líbano",
        LS:"Lesoto",
        LR:"Libéria",
        LY:"Líbia",
        LI:"Liechtenstein",
        LT:"Lituânia",
        LU:"Luxemburgo",
        MO:"Macau",
        MG:"Madagascar",
        MW:"Malawi",
        MY:"Malásia",
        MV:"Maldivas",
        ML:"Mali",
        MT:"Malta",
        MH:"Ilhas Marshall",
        MQ:"Martinica",
        MR:"Mauritânia",
        MU:"Maurícia",
        YT:"Mayotte",
        MX:"México",
        FM:"Micronésia",
        MD:"Moldávia",
        MC:"Mónaco",
        MN:"Mongólia",
        ME:"Montenegro",
        MS:"Montserrate",
        MA:"Marrocos",
        MZ:"Moçambique",
        MM:"Myanmar",
        NA:"Namíbia",
        NR:"Nauru",
        NP:"Nepal",
        NL:"Países Baixos",
        NC:"Nova Caledónia",
        NZ:"Nova Zelândia",
        NI:"Nicaragua",
        NE:"Niger",
        NG:"Nigéria",
        NU:"Niue",
        NF:"Ilha Norfolk",
        KP:"Coréia do Norte",
        MK:"Macedónia do Norte",
        MP:"Ilhas Marianas Setentrionais",
        NO:"Noruega",
        OM:"Omã",
        PK:"Paquistão",
        PW:"Palau",
        PS:"Palestina",
        PA:"Panamá",
        PG:"Papua Nova Guiné",
        PY:"Paraguai",
        PE:"Peru",
        PH:"Filipinas",
        PN:"Ilhas Pitcairn",
        PL:"Polónia",
        PT:"Portugal",
        PR:"Porto Rico",
        QA:"Catar",
        RE:"Reunião",
        RO:"Roménia",
        RU:"Rússia",
        RW:"Ruanda",
        WS:"Samoa",
        SM:"São Marino",
        ST:"São Tomé e Príncipe",
        SA:"Arábia Saudita",
        SN:"Senegal",
        RS:"Sérvia",
        SC:"Seicheles",
        SL:"Serra Leoa",
        SG:"Singapura",
        SX:"São Martinho (Países Baixos)",
        SK:"Eslováquia",
        SI:"Eslovénia",
        SB:"Ilhas Salomão",
        SO:"Somália",
        ZA:"África do Sul",
        GS:"Ilhas Geórgia do Sul e Sandwich do Sul",
        KR:"Coréia do Sul",
        SS:"Sudão do Sul",
        ES:"Espanha",
        LK:"Sri Lanka",
        BL:"São Bartolomeu",
        SH:"Santa Helena",
        KN:"São Cristóvão e Neves",
        LC:"Santa Lúcia",
        MF:"São Martinho (França)",
        PM:"São Pedro e Miquelão",
        VC:"São Vicente e Granadinas",
        SD:"Sudão",
        SR:"Suriname",
        SJ:"Svalbard e Jan Mayen",
        SE:"Suécia",
        CH:"Suíça",
        SY:"Síria",
        TW:"Taiwan",
        TJ:"Tajiquistão",
        TZ:"Tanzânia",
        TH:"Tailândia",
        TL:"Timor-Leste",
        TG:"Togo",
        TK:"Toquelau",
        TO:"Tonga",
        TT:"Trindade e Tobago",
        TN:"Tunísia",
        TR:"Turquia",
        TM:"Turquemenistão",
        TC:"Ilhas Turcas e Caicos",
        TV:"Tuvalu",
        UM:"Ilhas Menores Distantes dos Estados Unidos",
        VI:"Ilhas Virgens Americanas",
        UG:"Uganda",
        UA:"Ucrânia",
        AE:"Emirados Árabes Unidos",
        GB:"Reino Unido",
        US:"Estados Unidos",
        UY:"Uruguai",
        UZ:"Uzbequistão",
        VU:"Vanuatu",
        VA:"Vaticano",
        VE:"Venezuela",
        VN:"Vietname",
        WF:"Wallis e Futuna",
        EH:"Saara Ocidental",
        YE:"Iémen",
        ZM:"Zâmbia",
        ZW:"Zimbábue"
    },
  };
  
  export default countryTranslations;

  export const translateCountry = (key, language) => {
    return countryTranslations[language]?.[key] || countryTranslations['en'][key] || key;
  };
  